
var $54b47fc030b7b21e$var$burgerMenu = document.getElementById("burger-menu");
var $54b47fc030b7b21e$var$overlay = document.getElementById("menu");
$54b47fc030b7b21e$var$burgerMenu.addEventListener("click", function() {
    this.classList.toggle("close");
    $54b47fc030b7b21e$var$overlay.classList.toggle("overlay");
});


//# sourceMappingURL=index.60645986.js.map
